"use client";
import { memo } from "react";

import { CompactArtistDisplay } from "@/components/compactArtistDisplay/CompactArtistDisplay";
import { LazyRender } from "@/components/LazyRender";
import { useTutorial } from "@/lib/zustand/useTutorial/useTutorial";
import {
  Artist,
  ArtistInstumentSaved,
  Instrument,
  MixedModelConstructedNoDates,
  ModelNoDates,
  UserNoDates,
} from "@/types/types";

function UnmemoizedVoiceGrid({
  voices,
  handleClickArtist,
  user,
  savedArtistsInstrumentsIds,
}: {
  voices: (Artist | Instrument | ModelNoDates | MixedModelConstructedNoDates)[];
  handleClickArtist: (artistId: string) => void;
  user: UserNoDates | null;
  savedArtistsInstrumentsIds: ArtistInstumentSaved["artistInstrumentId"][];
}) {
  // Don't lazy render when tutorial is active since the artist card might not be visible then which breaks the tutorial
  const isActive = useTutorial((state) => state.isActive);

  return (
    <ul className="grid grid-cols-2 gap-x-3 gap-y-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
      {voices.map((voiceItem) =>
        isActive ?
          <CompactArtistDisplay
            key={voiceItem.id}
            artistInstrumentModelMixedModel={voiceItem}
            handleClickArtist={handleClickArtist}
            user={user}
            elementType="li"
            savedArtistsInstrumentsIds={savedArtistsInstrumentsIds}
          />
        : <LazyRender key={voiceItem.id}>
            <CompactArtistDisplay
              artistInstrumentModelMixedModel={voiceItem}
              handleClickArtist={handleClickArtist}
              user={user}
              elementType="li"
              savedArtistsInstrumentsIds={savedArtistsInstrumentsIds}
            />
          </LazyRender>
      )}
    </ul>
  );
}

export const VoiceGrid = memo(UnmemoizedVoiceGrid);
